import type { CreateAgreementCommandData } from '@festina/life-general-types/life'
import { EmployerAgreementsGenerateService } from '@festina/life-general-types/life/services/EmployerAgreementsGenerateService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

import type { EmployerAgreementActionProps } from '../types'

const method =
  EmployerAgreementsGenerateService.generateEmployerAgreementsServicePostEntity

export const useCreateEmployerAgreementGenerateIdCreateCommand = ({
  tenantId,
}: Except<EmployerAgreementActionProps, 'employerAgreementId'>) =>
  useFestinaMutation({
    component: 'life',
    roles:
      EmployerAgreementsGenerateService.generateEmployerAgreementsServicePostEntity_roles,
    isScenario: false,
    mutateFunction: async (arg: CreateAgreementCommandData) => {
      await method({
        xTenantId: tenantId,
        requestBody: arg,
      })
    },
  })
